/* global FWP, fSelect */

const $ = window.jQuery;

export default class FaceWP {
  constructor() {
    this.selectors = {
      table: '.js-products-table-sort',
      column: '.js-products-table-sort-column',
      sortFacetName: '[data-type="sort"][data-name^="sort_"]',
      facetWp: {
        sort: '.facetwp-type-sort',
        facet: '.facetwp-facet',
        template: '.facetwp-template',
        label: '.fs-label',
        dropdown: '.fs-wrap',
      },
      reset: '.js-facet-reset',
    };

    this.excludedFacets = [
      'sort_spirit',
      'sort_wine',
      'reviews_pagination',
      'results_count',
    ];

    this.classes = {
      desc: 'is-desc',
      active: 'is-active',
      loading: 'is-loading',
      hidden: 'u-hidden',
    };

    this.dropdown = null;
    this.isLoading = false;
    this.orderOptions = ['asc', 'desc'];
  }

  init() {
    if (typeof FWP === 'undefined') {
      return;
    }
    this.bindClickEvents();
    this.bindFacetWPLoaded();
    this.bindFacetRefresh();
  }

  bindClickEvents() {
    $(document).on('click', this.selectors.column, event => {
      event.preventDefault();
      this.sortColumn($(event.currentTarget));
    });
  }

  sortColumn(sortColumn) {
    const order = sortColumn.attr('data-order');
    const sortField = sortColumn.attr('data-sort-field');
    const facetName = $(this.selectors.sortFacetName).attr('data-name');
    const orderValue = `${sortField}_${order}`;
    this.isLoading = true;
    this.toggleTableState();

    FWP.facets[facetName] = [orderValue];
    FWP.setHash();
    FWP.fetchData();
  }

  updateCurrentColumnSettings() {
    const table = $(this.selectors.table);
    const sort = table.data('sort');
    const sortValues =
      FWP.facets[sort].length === 1 ? FWP.facets[sort][0].split('_') : [];
    if (sortValues.length) {
      const newOrder = sortValues[1] === 'asc' ? 'desc' : 'asc';
      const currentColumn = $(`[data-sort-field="${sortValues[0]}"`);
      $(this.selectors.column)
        .removeClass(this.classes.active)
        .removeClass(this.classes.desc);
      currentColumn.addClass(this.classes.active).attr('data-order', newOrder);

      if (newOrder === 'asc') {
        currentColumn.addClass(this.classes.desc);
      }
    }
  }

  setDefaultSorting() {
    const table = $(this.selectors.table);
    const sort = table.data('sort');
    if (!FWP.facets[sort].length) {
      FWP.facets[sort] = ['producer_asc'];
      FWP.setHash();
    }
  }

  bindFacetWPLoaded() {
    document.addEventListener('facetwp-loaded', () => {
      this.isLoading = false;
      this.setDefaultSorting();
      this.updateCurrentColumnSettings();
      this.toggleTableState();
      this.triggerSortDropdown();

      const allKeys = Object.keys(FWP.facets);
      allKeys.forEach(facet => {
        if (FWP.facets[facet].length && !this.excludedFacets.includes(facet)) {
          this.showHiddenElements();
        }
      });
    });
  }

  showHiddenElements() {
    $(`${this.selectors.facetWp.facet}.${this.classes.hidden}`).removeClass(
      this.classes.hidden,
    );
    $(`${this.selectors.facetWp.template}.${this.classes.hidden}`).removeClass(
      this.classes.hidden,
    );
    $(this.selectors.facetWp.sort)
      .parents(`.${this.classes.hidden}`)
      .removeClass(this.classes.hidden);
  }

  toggleTableState() {
    const table = $(this.selectors.table);
    if (this.isLoading) {
      table.addClass(this.classes.loading);
    } else {
      table.removeClass(this.classes.loading);
    }
  }

  triggerSortDropdown() {
    if (fSelect !== 'undefined') {
      const sortFacet = $(this.selectors.facetWp.sort);
      const select = sortFacet.find('select');

      if (this.dropdown === null) {
        this.dropdown = fSelect(select[0], {
          showSearch: false,
        });
      }

      sortFacet
        .find(this.selectors.facetWp.label)
        .attr('data-value', select.val());
    }
  }

  maybeEnableResetButton() {
    const resetButton = $(this.selectors.reset);
    const allKeys = Object.keys(FWP.facets);
    resetButton.attr('disabled', true);
    allKeys.forEach(facet => {
      if (FWP.facets[facet].length && !this.excludedFacets.includes(facet)) {
        resetButton.attr('disabled', false);
      }
    });
  }

  bindFacetRefresh() {
    document.addEventListener('facetwp-refresh', () => {
      this.maybeEnableResetButton();
    });
  }
}
